export default {
  clues: 'Hinweis {id}',
  question: 'Frage {id}',
  startQuiz: 'Zum Quiz',
  nextClue: 'Nächster Hinweis',
  prevClue: 'Voriger Hinweis',
};
